import { render } from "./FavSupplierComponent.vue?vue&type=template&id=1f398496&scoped=true"
import script from "./FavSupplierComponent.vue?vue&type=script&lang=js"
export * from "./FavSupplierComponent.vue?vue&type=script&lang=js"

import "./FavSupplierComponent.vue?vue&type=style&index=0&id=1f398496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f398496"]])

export default __exports__